import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=00fe89ec&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=00fe89ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe89ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fe89ec')) {
      api.createRecord('00fe89ec', component.options)
    } else {
      api.reload('00fe89ec', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=00fe89ec&scoped=true&", function () {
      api.rerender('00fe89ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JThRCuEB0fcF/JS/comp/GuestBox.vue"
export default component.exports